import React from "react";

import { format } from "date-fns";

const presets = [
  { value: "7days", label: "Last 7 Days" },
  { value: "30days", label: "Last 30 Days" },
  { value: "90days", label: "Last 90 Days" },
  { value: "12months", label: "Last 12 Months" },
  { value: "ytd", label: "Year to Date" },
  { value: "custom", label: "Custom Range" },
];

const DateRangePicker = ({ value, onChange }) => {
  const today = format(new Date(), "yyyy-MM-dd");

  const handlePresetChange = (e) => {
    const selected = e.target.value;

    if (selected === "custom") {
      onChange({ type: "custom", preset: "custom", start: "", end: "" });
    } else {
      onChange({ type: "preset", preset: selected, start: "", end: "" });
    }
  };

  const handleStartChange = (e) => {
    onChange({
      type: "custom",
      preset: "custom",
      start: e.target.value,
      end: value.end,
    });
  };

  const handleEndChange = (e) => {
    onChange({
      type: "custom",
      preset: "custom",
      start: value.start,
      end: e.target.value,
    });
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <select
        className="input w-full sm:w-44"
        value={value.preset}
        onChange={handlePresetChange}
      >
        {presets.map((p) => (
          <option key={p.value} value={p.value}>
            {p.label}
          </option>
        ))}
      </select>

      {value.type === "custom" && (
        <>
          <input
            className="input w-36"
            max={value.end || today}
            type="date"
            value={value.start}
            onChange={handleStartChange}
          />
          <span className="text-gray-400">to</span>
          <input
            className="input w-36"
            max={today}
            min={value.start}
            type="date"
            value={value.end}
            onChange={handleEndChange}
          />
        </>
      )}
    </div>
  );
};

export default DateRangePicker;
